<div class="toster_outerWrapper">

  <div class="toster_box">
    <div class="d-flex align-items-start" [class.align-items-center]="data.type==0">
      <span class="succes_icon success_bg flex-none" [class.mt-5]="data.type==1" *ngIf="data.type==0">
        <mat-icon>check</mat-icon>
      </span>
      <span class="succes_icon error_bg mt-5" *ngIf="data.type==1">
        <mat-icon>clear</mat-icon>
      </span>
      <div class="ml-10">
        <h4 [class.mb-0]="data.type==0">{{data.title | translate}}</h4>
        <p *ngIf="data.type==1">{{data.description | translate}}</p>
      </div>

    </div>
    <!-- commneted for hide dismiss button by client issue - 9380 -->
    <!-- <div class="d-flex justify-content-center align-items-center">
      <button type="button" class="bx-btn ml-0 mr-0 text-uppercase font-weight-600"  (click)="close()"> {{"Dismiss" | translate}} </button>
    </div> -->
    <button type="button" class="close_icon bx-btn-icon-fill btn-bg-dark bx-dialog-close-btn" (click)="close()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
